import UserProfileDevicesDataGrid from './UserProfileDevicesDataGrid';

export default UserProfileDevicesDataGrid;
